<template>
  <div>
    <div class="form-group mb-0">
      <input type="text"
             autocomplete="off"
             class="search-input"
             :placeholder="Lang.get('js.search')"
             @keydown.enter="search"
             v-model="query">
      <button class="btn-search btn btn-primary" @click="search" :disabled="query === ''">
        <i class="fa fa-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
      name: 'service-search',
      data() {
          return {
              defaultLanguage,
              query: '',
              show: false,
              loading: false,
              searchUrl: '/service/search/fraze-{0}',
              Lang,
          }
      },
      methods: {
          urlProductSearch(url) {
              if (this.Lang.locale !== this.defaultLanguage) {
                  url = '/' + this.Lang.locale + url;
              }
              return url;
          },
          search() {
              location = this.urlProductSearch(this.searchUrl).format(this.query);
          }
      }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/service/ServiceSearch.vue